import React, { PureComponent } from 'react';
import strings from 'helper/localization/localization';

export default class SignupPrivacy extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      acceptedTermsOfService: false,
      acceptedPrivacyPolicy: false,
      errorMessage: null,
    };

    this.updateDetails = this.props.updateDetails;
    this.toNextStep = this.toNextStep.bind(this);
    this.termsChanged = this.termsChanged.bind(this);
    this.privacyChanged = this.privacyChanged.bind(this);
  }

  toNextStep(e) {
    e.preventDefault();
    this.setState({ errorMessage: null });

    if (!this.state.acceptedTermsOfService || !this.state.acceptedPrivacyPolicy) {
      this.setState({ errorMessage: strings.mustAcceptTerms });
    } else {
      this.updateDetails('acceptedTermsOfService', true);
      this.updateDetails('acceptedPrivacyPolicy', true);
    }
  }

  termsChanged(e) {
    this.setState({ acceptedTermsOfService: e.target.checked });
  }

  privacyChanged(e) {
    this.setState({ acceptedPrivacyPolicy: e.target.checked });
  }

  render() {
    const errorMessage = this.state.errorMessage ?
      <p className="text-danger">{this.state.errorMessage}</p> : null;

    return (
      <div>
        <div className="row">
          <div className="col">
            <p>
              <strong>
                {strings.quickSummary}{' '}
                <a href={strings.privacyPolicyLink} target="_blank" rel="noopener noreferrer">{strings.navPrivacyPolicy}</a>{':'}
              </strong>
            </p>
            <ul>
              <li>{strings.privacySummary1}</li>
              <li>{strings.privacySummary2}</li>
            </ul>
            <p>
              <strong>
                {strings.quickSummary}{' '}
                <a href={strings.termsOfUseLink} target="_blank" rel="noopener noreferrer">{strings.navTermsOfUse}</a>{':'}
              </strong>
            </p>
            <ul>
              <li>{strings.termsSummary1}</li>
              <li>{strings.termsSummary2}</li>
            </ul>
          </div>
        </div>
        <form>
          <div className="row">
            <div className="col">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="privacyCheck"
                  onChange={this.privacyChanged}
                />
                <label className="form-check-label" id="privacy-label" htmlFor="privacyCheck">
                  {strings.readAndAcceptPrivacy}
                </label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="termsCheck"
                  onChange={this.termsChanged}
                />
                <label className="form-check-label" id="privacy-label" htmlFor="termsCheck">
                  {strings.readAndAcceptTerms}
                </label>
              </div>
            </div>
          </div>
          { errorMessage }
          <button
            type="submit"
            className="btn btn-outline-primary btn-lg btn-block"
            onClick={this.toNextStep}
            id="signup-terms--save"
          >
            {strings.iAcceptBoth}
          </button>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/signup/components/SignupPrivacy.jsx